import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminArticleQuery.ts
var r = (r) => t({
	queryKey: e.article(r),
	queryFn: () => n.adminGetArticle(r),
	enabled: !!r
});
//#endregion
export { r as useAdminArticleQuery };
